import MIconButton from "@mui/material/IconButton";
import styled from "@mui/material/styles/styled";
const IconButton = styled(MIconButton)({
  padding: 0,
  margin: 0,
  "& .MuiIconButton-label": {
    width: "auto",
    height: "auto"
  },
  "&:hover": {
    backgroundColor: "transparent",
    color: "currentcolor"
  }
});
var IconButton_default = IconButton;
export {
  IconButton_default as default
};
